/// <amd-module name="SuiteCommerce.GiftCertificate.Group.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.Group.Collection", ["require", "exports", "SuiteCommerce.GiftCertificate.Common.DependencyProvider", "SuiteCommerce.GiftCertificate.Group.Model", "SuiteCommerce.GiftCertificates.Collection", "SuiteCommerce.GiftCertificate.Model"], function (require, exports, DependencyProvider_1, Group_Model_1, GiftCertificate_Collection_1, GiftCertificate_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.GroupCollection = void 0;
    var GroupCollection = /** @class */ (function (_super) {
        __extends(GroupCollection, _super);
        function GroupCollection(models, options) {
            var _this = _super.call(this, models, options) || this;
            _this.url = '/app/site/hosting/scriptlet.nl?script=customscript_ns_sc_sl_gift_cert_groups' +
                '&deploy=customdeploy_ns_sc_sl_gift_cert_groups';
            _this.itemToGroupMap = {};
            if (models) {
                _this.generateItemToGroupMap(models);
            }
            return _this;
        }
        GroupCollection.prototype.getGroupById = function (id) {
            return this.findWhere({ recordid: id });
        };
        GroupCollection.prototype.parse = function (rawData) {
            var models = [];
            rawData.forEach(function (rawGroup) {
                var giftCertificates = [];
                rawGroup.giftCertificates.forEach(function (giftCertificateData) {
                    var giftCertificate = new GiftCertificate_Model_1.GiftCertificateModel(giftCertificateData);
                    giftCertificates.push(giftCertificate);
                });
                var groupModel = new Group_Model_1.GroupModel({
                    giftCertificates: new GiftCertificate_Collection_1.GiftCertificateCollection(giftCertificates),
                    isinactive: rawGroup.isinactive,
                    name: rawGroup.name,
                    recordid: rawGroup.recordid,
                });
                models.push(groupModel);
            });
            this.generateItemToGroupMap(models);
            return models;
        };
        GroupCollection.prototype.generateItemToGroupMap = function (models) {
            var _this = this;
            models.forEach(function (group) {
                group.giftCertificates.forEach(function (giftCertificate) {
                    _this.itemToGroupMap[giftCertificate.id] = group.id;
                });
            });
        };
        return GroupCollection;
    }(DependencyProvider_1.BackboneCachedCollection));
    exports.GroupCollection = GroupCollection;
});
